module.exports = __webpack_public_path__ + "static/media/assist-graphic.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Assist/img/assist-graphic.svg
// module id = 191
// module chunks = 0